"use strict";

(function () {
  'use strict';

  function AccountService($http, $q, AuthService) {
    var getProfile = function getProfile() {
      var deferred = $q.defer();
      $http.get('/profile/' + AuthService.getUser().userId).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    var updateProfile = function updateProfile(profile) {
      var deferred = $q.defer();
      $http.post('/profile/' + AuthService.getUser().userId, {
        firstName: profile.firstName || '',
        lastName: profile.lastName || '',
        address: profile.address || '',
        country: profile.country || '',
        city: profile.city || '',
        state: profile.state || '',
        zip: profile.zip || '',
        email: profile.email ? profile.email.toLowerCase() : '',
        phone: profile.phone || '',
        cellPhone: profile.cellPhone || '',
        workPhone: profile.workPhone || '',
        billingFirstName: profile.billingFirstName || '',
        billingLastName: profile.billingLastName || '',
        billingCountry: profile.billingCountry || '',
        billingAddress: profile.billingAddress || '',
        billingCity: profile.billingCity || '',
        billingState: profile.billingState || '',
        billingZip: profile.billingZip || '',
        billingPhone: profile.billingPhone || '',
        dateOfBirth: profile.dateOfBirth || ''
      }).then(function (response) {
        deferred.resolve(response.data);
      }, function (error) {
        deferred.reject(error.data);
      });
      return deferred.promise;
    };

    return {
      getProfile: getProfile,
      updateProfile: updateProfile
    };
  }

  AccountService.$inject = ['$http', '$q', 'AuthService'];
  angular.module('account-service', []).factory('AccountService', AccountService);
})();